import { FC } from 'react';
import 'shared/common/assets/colors.css';
import { withCommonProviders } from '../../../common/containers/CommonContextProviders';
import { IApplicationCommonRootComponentProps } from '../../../common/types/applicationRootComponent';
import { Form } from '../Form';

export const OfferCalculatorApp: FC<IApplicationCommonRootComponentProps> = withCommonProviders(() => <Form />);
